import React from "react";
import { SCHMODEL_INSTAGRAM_DM_URL } from "@schmodel/core";
import "./index.css";
import logo from "../../assets/images/schmodelplain-withR-white.png";

// Where Stripe sends the member if they leave Checkout without paying.
function PaymentCancelled() {
    return (
        <div className="payment-container">
            <div className="payment-main">
                <svg className="payment-icon" viewBox="0 0 48 48" aria-hidden="true">
                    <circle cx="24" cy="24" r="22" fill="none" stroke="#E04344" strokeWidth="1.5" />
                    <path d="M17 17l14 14M31 17L17 31" fill="none" stroke="#E04344" strokeWidth="1.5"
                          strokeLinecap="round" />
                </svg>

                Your payment was not completed.<br />
                Your membership is not active yet.

                <p className="payment-note">
                    Open the link in your acceptance email to try again.
                    If it has expired, <a className="payment-link" href={SCHMODEL_INSTAGRAM_DM_URL}>contact us</a> and
                    we will send a new one.
                </p>
            </div>
            <div className="payment-footer">
                <img src={logo} className="payment-logo" alt="Schmodel" />
            </div>
        </div>
    );
}

export default PaymentCancelled;
